import React from 'react';
import Typography from '../Typography';

export interface PieProps {
  value?: number;
  progress: 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;
  fill: string;
  stroke: string;
  width?: number;
  height?: number;
  cutColor?: string;
}

const Pie: React.FC<PieProps> = ({
  value,
  progress,
  fill,
  stroke,
  width = 64,
  height = 64,
  cutColor = '#FFFFFF',
}) => {
  return (
    <div className="ckp-a-pie" style={{ width, height, color: stroke }}>
      <svg
        height={height}
        width={width}
        viewBox="0 0 64 64"
        className="ckp-a-pie__chart"
        aria-hidden
      >
        <circle r={30} cx={32} cy={32} fill={fill} stroke={stroke} strokeWidth={2} />
        <circle
          r={16}
          cx={32}
          cy={32}
          fill="transparent"
          stroke={cutColor}
          strokeWidth={32}
          strokeDasharray={`${100 - progress} 100`}
          transform="rotate(-90) translate(-64)"
        />
      </svg>

      <Typography classNames="ckp-a-pie__value">{value}</Typography>
    </div>
  );
};

export default Pie;
